
import ListItemText from '@material-ui/core/ListItemText'

export default ListItemText